import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from 'src/app/service/state/state.service';
import { RouteComponent } from '../../route.component';
import { UserService } from '@app/service/user-service/user.service';

@Component({
  selector: 'app-de-pre-fts',
  templateUrl: './de-pre-fts.component.html',
  styleUrls: ['../../page-shared.css', './de-pre-fts.component.scss'],
})
export class DePreFtsComponent extends RouteComponent implements OnInit {
  loading = false;
  navigationInProgress = false;
  showOnboardingText = false;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected headerService: HeaderService,
    protected stateService: StateService,
    private userService: UserService
  ) {
    super(router, route, stateService, headerService);
  }

  ngOnInit(): void {
    if (this.route.snapshot.data.state.paymentInformation?.directDebit) {
      this.showOnboardingText = true;
    }
  }

  async handleCtaClick() {
    this.navigationInProgress = true;
    try {
      await this.navigate();
    } catch (err) {
      this.handleError(err);
    }
    this.navigationInProgress = false;
  }
}
